var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`min-width:${_vm.barChartRankingArrecadacao.chartData.labels.length * 8}px;max-width:100%;`)},[_c('horizontalBar-chart',{attrs:{"id":"bar-chart-ranking-arrecadao","height":250,"chart-data":_vm.barChartRankingArrecadacao.chartData,"extra-options":_vm.barChartRankingArrecadacao.extraOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }